import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    FormInstance,
    Cascader,
    TreeSelect,
    Spin,
    Space,
    Button,
    Row,
    Col,
    Upload,
    notification, Select, Table, Image, Radio, Tooltip, Tag
} from "antd";
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
    deleteTemplateMacWallpaper, addTemplateMacWallpaper, getTemplateMacWallpaper
} from "../../../axios/api.device"

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";
import { UploadChangeParam, UploadFile } from "antd/es/upload";

const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentMacWallpaper = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [dataForm] = Form.useForm();
    const [isUpload, setIsUpload] = useState<boolean>(false);
    const [imageUrl, setImageUrl] = useState<any>('');
    const [isAdd, setIsAdd] = useState<boolean>(false);
    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }
    useEffect(() => {
        getDataInfo()
    }, [])
    const getDataInfo = () => {
        getTemplateMacWallpaper(templateId).then((res) => {
            if (res && res != null && (res.picturePath || res.url)) {
                setIsUpload(res.isUpload);
                if(res.isUpload && res.url)
                    setImageUrl(res.url);
                setShowTable(2)
                setIsAdd(false);
                dataForm?.setFieldsValue(res);
            } else {
                setShowTable(1)
                setIsAdd(true);
                setIsUpload(true);
            }
        })
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                var req = {} as any;
                req.allowModification = res.allowModification;
                req.isUpload= res.isUpload;
                req.picturePath= res.isUpload ? '' :  res.picturePath;
                if(res.imageFile)
                    req.imageFile = res.imageFile[0]?.originFileObj;
                if(!res.isUpload)
                    setImageUrl('');
                console.log(req);
                addTemplateMacWallpaper(templateId, req).then(() => {
                    updateTemplate();
                    notification.success({ message: t("成功") });
                    getDataInfo();
                })
            })
    }
    const deleteTemplateClick = () => {
        dataForm.validateFields().then(() => {
            deleteTemplateMacWallpaper(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                dataForm.resetFields();
                getDataInfo();
            })
        })

    }

    const normFile = (e: any) => {
        if (Array.isArray(e)) {
        return e;
        }
        return e && e.fileList;
    };

    const beforeUpload = (file: File) => {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
            notification.error({ message: t("Image must smaller than 10MB!") });
        }
        return false;
    };
    function getBase64(img: any, callback: any) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
        callback(reader.result);
        console.log(reader);
        });
        reader.readAsDataURL(img);
    }
    const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
        getBase64(info.file, (imageUrl: any) => {
        setImageUrl(imageUrl);
        });
    };
    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle"> {t("桌面壁纸")}</Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (

                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置Mac桌面壁纸")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <Form
                            style={{ width: "90%", marginTop: 36 }}
                            layout="horizontal"
                            form={dataForm}
                            labelCol={{ span: 8 }}
                            initialValues={{ allowModification: true,isUpload: true }}
                        >
                            <Row>
                                <Col span={16}>
                                    <Item
                                        label={t("壁纸来源")}
                                        name="isUpload"
                                        rules={[{ required: true }]}
                                    >
                                        <Select style={{width:"50%"}} onChange={(key: boolean) => {
                                            setIsUpload(key);
                                        }}>
                                            <Select.Option value={true}>{t("本地上传")}</Select.Option>
                                            <Select.Option value={false}>{t("指定路径")}</Select.Option>
                                        </Select>
                                    </Item>
                                </Col>
                            </Row>
                            {isUpload && <Row>
                                <Col span={16}>
                                    <Item
                                        label={t("壁纸")}
                                        name="imageFile"
                                        valuePropName="fileList"
                                        getValueFromEvent={normFile}
                                        rules={[{ required: imageUrl != '' ? false: true }]}
                                        extra={t("壁纸尺寸需要符合设备尺寸，不大于10MB")}
                                    >
                                        <Upload
                                            maxCount={1}
                                            listType="picture-card"
                                            accept=".jpg,.jpeg,.png,.gif"
                                            showUploadList={false}
                                            beforeUpload={beforeUpload}
                                            onChange={handleChange}
                                        >
                                            {imageUrl ? (
                                            <img src={imageUrl} alt="avatar" style={{ width: "100%" }} />
                                            ) : (
                                            "+"
                                            )}
                                        </Upload>
                                    </Item>
                                </Col>
                            </Row>}
                            {!isUpload && <Row>
                                <Col span={16}>
                                    <Item
                                        label={t("桌面壁纸")}
                                        name="picturePath"
                                        rules={[{ required: true }]}
                                    >
                                        <Input
                                            placeholder={t("输入桌面壁纸的路径，例如：/Desktop/background.png")}
                                        >
                                        </Input>
                                    </Item>
                                </Col>
                            </Row>}
                            <Row>
                                <Col span={16}>
                                    <Item label={t("允许修改")} name="allowModification" 
                                        rules={[{ required: true }]} 
                                        extra={<><InfoCircleOutlined /> {t("选择否时，用户无法修改壁纸")}</>}>
                                        <Radio.Group>
                                            <Radio value={true}>{t("是")}</Radio>
                                            <Radio value={false}>{t("否")}</Radio>
                                        </Radio.Group>
                                    </Item>
                                </Col>
                                {/* <Col span={8} >
                                    <p style={{ marginLeft: "16px", textAlign: "left", lineHeight: "32px" }}><InfoCircleOutlined />&nbsp;&nbsp;&nbsp;用户无法修改壁纸</p>
                                </Col> */}
                            </Row>

                        </Form>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
        </div>

    </>)
};